import { render, staticRenderFns } from "./BaseEditor.vue?vue&type=template&id=66639087&"
import script from "./BaseEditor.vue?vue&type=script&lang=ts&"
export * from "./BaseEditor.vue?vue&type=script&lang=ts&"
import style0 from "./BaseEditor.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports